import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from '../../controls/tempRHFControls/RHFInputBox';

interface IYearQueryDialogProps {
    dialogName: string;
    hideDialog: () => void;
    defaultYear?: number;
    sendYear: (year: number) => void;
    dialogTitle?: string;
}

const YearQueryDialog = (props: IYearQueryDialogProps) => {
    const { register, getValues, reset } = useForm();

    const handleYearEntry = () => {
        props.sendYear(getValues().year);
        props.hideDialog();
        reset({ 'year': props.defaultYear });
    };

    useEffect(() => {
        reset({ 'year': props.defaultYear });
    }, [props.defaultYear]);

    const displayTitle = () => {
        return props.dialogTitle ? props.dialogTitle : 'Query Year';
    };

    return (
        <Dialog title={displayTitle()} dialogName={props.dialogName} bodyStyle={{ width: '12%' }}>
            <div>
                <form>
                    <div>
                        <RHFInputBox
                            name={'year'}
                            register={register}
                            style={{ width: '50%' }}
                            label={'Year: '}
                            type="number"
                            labelOnLeft={true}
                        />
                    </div>
                    <div className="form-row" style={{ marginTop: '2rem', marginLeft: '33%', textAlign: 'center' }}>
                        <Button
                            className="blue-hover-button"
                            intent="primary"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Save'}
                            onClick={() => handleYearEntry()}
                        />
                        <Button
                            className="blue-hover-button"
                            style={{ width: '24%', marginRight: '1rem' }}
                            text={'Cancel'}
                            onClick={() => props.hideDialog()}
                        />
                    </div>
                </form>
            </div>
        </Dialog>
    );
};

export default YearQueryDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/QueryYearDialog.tsx